// extracted by mini-css-extract-plugin
export default {"root":"t4kkhoalnj","previousNext":"p2rXZeSC23"};